module.exports = __webpack_public_path__ + "img/1.28_Russian_road_sign.9eacb01b.svg";